import { ReactNode } from "react"
import { useAppSelector } from "../../app/hooks"
import {
    catalogRequirementFeatureFlag,
    departmentConfigurationFeatureFlag,
    documentSysUpdateFeatureFlag,
    documentTypeConfigurationFeatureFlag,
    dynamicUrsFeatureFlag,
    selectCompanyFeatureFlags,
    selectHasFeatureFlag,
} from "./settingsSlice"

export const CompanyFeatureFlags = {
    CatalogRequierment: catalogRequirementFeatureFlag,
    DocumentTypeConfiguration: documentTypeConfigurationFeatureFlag,
    DepartmentConfiguration: departmentConfigurationFeatureFlag,    
    DynamicUrs: dynamicUrsFeatureFlag,
    DocumentSysUpdate: documentSysUpdateFeatureFlag
} as const

export type CompanyFeatureFlagCode = typeof CompanyFeatureFlags[keyof typeof CompanyFeatureFlags] | string

export const useCompanyFeatureFlags = () => useAppSelector(selectCompanyFeatureFlags)

export const useHasFeatureFlag = (featureFlagCode: CompanyFeatureFlagCode) =>
    useAppSelector(selectHasFeatureFlag(featureFlagCode))

interface FeatureFlagGuardProps {
    flag: CompanyFeatureFlagCode
    children: ReactNode
    fallback?: ReactNode
}

export const FeatureFlagGuard = ({ flag, children, fallback = null }: FeatureFlagGuardProps) => {
    const hasFeatureFlag = useHasFeatureFlag(flag)

    if (!hasFeatureFlag) {
        return <>{fallback}</>
    }

    return <>{children}</>
}
